import { Modal, type WrappedButtonProps } from '@socrait/react';

type LeftoversModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export function LeftoversModal({ isOpen, onClose, onContinue }: LeftoversModalProps) {
  const buttons: WrappedButtonProps[] = [
    {
      name: 'Go Back',
      onPress: onClose,
    },
    {
      name: 'Continue',
      onPress: onContinue,
      variant: 'primary',
    },
  ];

  return (
    <Modal
      title={'Did you forget something?'}
      content={
        'Looks like you were in the middle of adding a student name. If so, go back and press enter to add the student before saving.'
      }
      buttons={buttons}
      modalVisible={isOpen}
      handleClose={onClose}
      buttonLayout="row"
    />
  );
}
